import { getCurrentUser, getSubteam } from '../services/store-service';
import { canUser } from '../services/permissions-service';

export const hasSubteamAccess = subteamId => {
    const currentUser = getCurrentUser();

    if (canUser('fullAccess')) {
        return true;
    }

    const subteam = getSubteam(subteamId);

    return subteam && (subteam.owner === currentUser.id || (subteam.members && subteam.members.includes(currentUser.id)));
}
